var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-slider"},[_c('div',{ref:"slider",staticClass:"slider"}),(_vm.hideLabel !== true)?_c('div',{staticClass:"label"},[_vm._v(" "+_vm._s(_vm.localState)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }